module.exports = __webpack_public_path__ + "img/oti_2.fcfce699.jpg";